<template>
  <div class="header-wrap">
    <div class="header-login">
      <!-- <div class="content"> -->
        <img class="phone-img" src="../assets/images/header_phone.png" alt="">
        <span class="phone">400-061-6167</span>
        <span class="login-btn" @click="goLogin">登录</span>
        <!-- <span class="register-btn" @click="goRegister">注册</span> -->
      <!-- </div> -->
    </div>
    <div class="header-content">
      <img class="header-logo" src="../assets/images/logo.png" alt="">
      <div @click="changePage(item.value)" class="header-item" :class="currentRoute === item.value ? 'header-item-actived' : ''" v-for="(item, index) in headerList" :key="index">{{item.title}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headerList: [{
        title: '首页',
        value: 'index'
      }, {
        title: '解决方案',
        value: 'solution'
      }, {
        title: '合作案例',
        value: 'case'
      }, {
        title: '合作支持',
        value: 'support'
      }, 
      // {
      //   title: '数字校园',
      //   value: 'digital'
      // }, 
      {
        title: '关于我们',
        value: 'about'
      }]
    }
  },
  computed: {
    currentRoute() {
      return this.$route.params.type || 'index'
    }
  },
  methods: {
    changePage(type) {
      this.$emit('changePages', type)
    },
    goLogin() {
      let url = this.$router.resolve({
        path: '/login'
      })
      window.open(url.href, '_blank')
    },
    // goRegister() {
    //   let url = this.$router.resolve({
    //     path: '/register'
    //   })
    //   window.open(url.href, '_blank')
    // }
  }
}
</script>
<style lang="scss" scoped>
.header-wrap {
  background: #fff;
  .header-login {
    display: flex;
    // justify-content: space-around;
    justify-content: flex-end;
    align-items: center;
    height: 42px;
    line-height: 42px;
    background: #B5B5B6;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    padding-right: calc((100% - 1004px) / 2 + 70px);
    .login-btn {
      padding-right: 28px;
      cursor: pointer;
    }
    .register-btn {
      cursor: pointer;
    }
    .phone-img {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
    .phone {
      font-size: 18px;
      padding-right: 24px;
    }
  }
  .header-content {
    width: 100%;
    height: 88px;
    padding-top: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    .header-logo {
      width: 180px;
      height: 42px;
      margin-right: 92px;
    }
    .header-item {
      width: 112px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 500;
      color: #000000;
      margin-right: 12px;
      cursor: pointer;
    }
    .header-item:last-child {
      margin-right: 0
    }
    .header-item-actived {
      color: #217CFE;
      border-bottom: 2px solid #217CFE;
    }
  }
}
</style>
